<template>
    <div class="mx-auto rounded-lg">
        <div class="px-4">
            <div class="flex py-3 justify-start">
                <div class="items-">
                    <icon name="alert-warning" class="w-10 h-10 mr-5"/>
                </div>
                <div class="text-sm text-gray-700 my-auto" v-if="text && text.length > 0">{{ text }}</div>
                <div class="text-sm text-gray-700" v-if="!text">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "@/Shared/Icon";

export default {
    components: {
        Icon
    },
    name: 'Warning',
    props: {
        text: String,
    }
}
</script>
